import React, { useEffect, useRef } from "react";
import { settlePromise, usePromiseAsk } from "./promiseStore";
import type { PromiseAsk } from "./promiseStore";
import "./promiseDialog.css";

// The promise modal, once per page that changes pre-orders (today's prints, collectibles). It sits
// inside the page so it keeps the store's colours; showModal() lifts it above everything else.

export const PromiseDialogHost: React.FC = () => {
  const ask = usePromiseAsk();
  const ref = useRef<HTMLDialogElement>(null);
  const confirmRef = useRef<HTMLButtonElement>(null);
  const dismissRef = useRef<HTMLButtonElement>(null);
  // the last question stays on screen while the dialog closes
  const shown = useRef<PromiseAsk | null>(null);
  if (ask) shown.current = ask;
  const view = shown.current;

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (ask && !dialog.open) {
      if (typeof dialog.showModal === "function") dialog.showModal();
      else dialog.setAttribute("open", "");
      // a removal starts on "keep it", a promise on its button
      (ask.final ? dismissRef : confirmRef).current?.focus();
    }
    if (!ask && dialog.open) {
      if (typeof dialog.close === "function") dialog.close();
      else dialog.removeAttribute("open");
    }
  }, [ask]);

  return (
    <dialog
      ref={ref}
      className={`pd ${view?.final ? "pd--final" : ""}`}
      aria-labelledby="pd-title"
      onClose={() => settlePromise(false)}
      onClick={(e) => {
        if (e.target === ref.current) settlePromise(false);
      }}
    >
      {view && (
        <div className="pd-inner">
          <h2 id="pd-title" className="pd-title">
            {view.title}
          </h2>
          {view.body.map((line) => (
            <p key={line} className="pd-text">
              {line}
            </p>
          ))}
          <div className="pd-actions">
            <button ref={dismissRef} type="button" className="tp-link-btn" onClick={() => settlePromise(false)}>
              {view.dismiss}
            </button>
            <button ref={confirmRef} type="button" className="sf-buy pd-confirm" onClick={() => settlePromise(true)}>
              <span className="sf-stretch">{view.confirm}</span>
            </button>
          </div>
        </div>
      )}
    </dialog>
  );
};

export default PromiseDialogHost;
